import { Dealer } from "@/types/dealer";
import { DealerFilterState } from "./types";
import {
  PaginationOptions,
  PaginationResult,
  calculatePagination,
  createPaginationResult
} from "./services/paginationService";
import {
  executeEnhancedQuery
} from "./services/enhancedDealerQueryService";
import {
  processDealer
} from "./services/dealerDataProcessor";

/**
 * Enhanced paginated dealer fetching with intelligent distance-based sorting
 * Integrates the same smart sorting logic used by recommended dealers
 */
export const fetchDealersDataPaginated = async (
  options: PaginationOptions
): Promise<PaginationResult<Dealer>> => {
  const { page, limit, filters, coordinates, city, signal } = options;
  const { offset } = calculatePagination(page, limit);

  try {
    console.log(`🔍 fetchDealersDataPaginated: Fetching dealers page ${page}, limit ${limit}, offset ${offset}`);
    console.log(`📊 Enhanced sorting enabled with coordinates:`, !!coordinates);

    // Use the enhanced query service that includes intelligent sorting
    const { data: dealersData, error: dealersError, count } = await executeEnhancedQuery(
      filters,
      coordinates,
      offset,
      limit,
      city,
      signal
    );

    if (dealersError) {
      console.error("Error fetching dealers with enhanced sorting:", dealersError);
      throw dealersError;
    }

    if (!dealersData || dealersData.length === 0) {
      console.log("No dealers data returned from enhanced query");
      return createPaginationResult([], 0, offset, limit);
    }

    console.log(`📦 Enhanced query returned ${dealersData.length} dealers`);

    // Process the dealer data (ratings, etc.)
    const { dealers, totalCount } = await processDealer(dealersData, count);
    
    console.log(`✅ Processed ${dealers.length} dealers for pagination result`);
    
    return createPaginationResult(dealers, totalCount, offset, limit);

  } catch (error: any) {
    if (error.name === 'AbortError') throw error;
    
    console.error("Error in fetchDealersDataPaginated:", error);
    throw error;
  }
};
